import { render } from "./RadioInputComponent.vue?vue&type=template&id=5885362c&scoped=true"
import script from "./RadioInputComponent.vue?vue&type=script&lang=js"
export * from "./RadioInputComponent.vue?vue&type=script&lang=js"

import "./RadioInputComponent.vue?vue&type=style&index=0&id=5885362c&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5885362c"]])

export default __exports__